import { Skeleton } from '@chakra-ui/react';
import React from 'react';

const RaffleCardSkeleton = () => (
  <Skeleton
    minWidth='300px'
    minHeight='400px'
    rounded='1.5rem'
  />
)


export default RaffleCardSkeleton